// extracted by mini-css-extract-plugin
export default {"container":"yG-z","innerContainer":"zG-z","multipleLines":"AG-z","heading":"BG-z","content":"CG-z","linkColor":"DG-z"};